export default function ($http) {
    return function (vehicleId, tagId) {
        return $http({
            url: `api/vehicle/${vehicleId}/tags/${tagId}`,
            method: 'DELETE'
        })
        .then(response => response.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/tags/services/deleteTag.js